import React from 'react';
import { Element } from './CardEbook.styles';
import { Title } from '@/components/typography';
import Image from '@/providers/Image';
import { useTranslations } from 'next-intl';

const CardEbook = () => {
  const t = useTranslations('Viagem');
  return (
    <Element>
      <Title as="h3" weight="semi_bold" textCase="uppercase" color="secondary_500" size="base">
        {t('Conheça o E-Book Lua de Mel')}
      </Title>
      <a href="https://conteudo.kangaroo.com.br/lua-de-mel-selecao" target="_blank">
        <Image
          src="https://assets-cdn.kangaroo.com.br/images/content/capa-ebook-lua-de-mel.jpg"
          alt={t('Lua de Mel')}
          width="300"
          height="225"
        />
      </a>
    </Element>
  );
};

export default CardEbook;
